import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { helpers, http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* getRequest(action) {}

function* postRequest(action) {
    const pbiPost = action.payload;
    const url = `${config.api.paths.powerbi}`;
    try {
        const accessToken = yield call(http.authorized.post, url, pbiPost);
        yield put(actionCreators.postSuccess(accessToken.data.token));
    } catch (error) {
        console.error(error);
        logToSentry("On powerbi post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([takeLatest(actionTypes.POWERBI_POST_REQUEST, postRequest)]);
}
